import { map, Observable, tap } from 'rxjs';
import { inject } from '@angular/core';
import { HostedGamesService } from '@hosted-games/infra';
import { DateFormatPipe } from '@ui-components';
import { mapToCreateGameResultUtil } from '../../utils/map-to-create-game-result.util';
import { CreateHostedGameDto, CreateHostedGameResponse } from '@core-http';
import { CreateGameCommandPayload } from './create-game.command-payload';
import { CreateGameCommandResult } from './create-game.command-result';
import { AppsFlyerService } from '@core';

export class CreateGameCommandHandler {
  private readonly hostedGamesService: HostedGamesService = inject(HostedGamesService);
  private readonly dateFormatPipe: DateFormatPipe = inject(DateFormatPipe);
  private readonly appsFlyerService: AppsFlyerService = inject(AppsFlyerService);

  createGame(game: CreateGameCommandPayload): Observable<CreateGameCommandResult> {
    const payload: CreateHostedGameDto = {
      ...(game as any),
      gameContactPhone: game.gameContactPhone ? `+48${game.gameContactPhone}` : null,
      priceAmount: game.priceAmount.toString(),
      paymentTypes: !game.priceAmount ? [] : game.paymentTypes,
      teamId: game.teamId ?? undefined
    };

    return this.hostedGamesService.createGame(payload).pipe(
      map((response: CreateHostedGameResponse) => mapToCreateGameResultUtil(response, this.dateFormatPipe)),
      tap(() => {
        this.appsFlyerService.logEvent('fb_creategame');
      })
    );
  }
}
